import { yAxisSplitLine, LegendTextStyle } from './echartOptionCommon'
export function totalCallTrendEchartOp ({ v }) {
  let option = {
    color: ['rgba(255, 95, 165, 1)', 'rgba(0, 114, 255, 1)'],
    grid: {
      left: '0%',
      top: '15%',
      right: '0%',
      bottom: '0%',
      containLabel: true
    },
    legend: {
      icon: 'circle',
      data: ['累计激活', '活跃量'],
      ...LegendTextStyle({ v })
    },
    xAxis: {
      name: '月',
      type: 'category',
      data: ['2021-08', '2021-09', '2021-10', '2021-11', '2021-12', '2022-01', '2022-02'],
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)',
        rotate: 25
        // fontSize: v.fontSizeRem(0.75)
      }
    },
    yAxis: {
      name: '万',
      type: 'value',
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)',
        formatter: function (d, c, a) {
          return v.numberSplitWithComma(d / 10000)
        }
        // fontSize: v.fontSizeRem(0.75)
      },
      splitLine: yAxisSplitLine,
      nameTextStyle: {
        color: 'rgba(255, 255, 255,1)'
      }
    },
    series: [
      {
        name: '活跃量',
        data: [
          6506912,
          6023954,
          6045267,
          5045726,
          5252416,
          6962457,
          7077351
        ],
        type: 'line',
        smooth: true,
        symbol: 'none'
      },
      {
        name: '累计激活',
        barWidth: v.fontSizeRem(0.23),
        data: [
          20397111,
          20378920,
          20438708,
          20422029,
          20418954,
          20742995,
          20297316
        ],
        type: 'bar',
        smooth: true,
        symbol: 'none'
      }

    ]
  }
  return option
}
export function dayCallTrendEchartOp ({ v, data }) {
  let option = {
    grid: {
      left: '0%',
      top: '15%',
      right: '0%',
      bottom: '0%',
      containLabel: true
    },
    color: ['rgba(34, 186, 250, 1)', 'rgba(38, 98, 255, 1)', 'rgba(159, 75, 248, 1)'],
    legend: {
      icon: 'circle',
      data: [...data.name],
      ...LegendTextStyle({ v })
    },
    xAxis: {
      type: 'category',
      data: [...data.date],
      // data: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      }
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      },
      splitLine: yAxisSplitLine
    },
    series: data.data.map((item, index) => {
      return {
        name: data.name[index],
        stack: '总量',
        data: [...item],
        type: 'bar',
        barWidth: v.fontSizeRem(0.23)
      }
    })
    // series: [
    //   {
    //     name: '遥控器',
    //     stack: '总量',
    //     data: [
    //       1207840,
    //       1029439,
    //       1019169,
    //       1070659,
    //       1097099,
    //       1136901,
    //       1143844,
    //       1106702,
    //       1097625,
    //       1084601,
    //       1083328,
    //       1084124,
    //       1081088,
    //       998038,
    //       1014559,
    //       952302,
    //       898173,
    //       938125,
    //       1078817,
    //       1056199,
    //       802043,
    //       796470,
    //       773561,
    //       759716,
    //       837902,
    //       1016535,
    //       994117,
    //       742806
    //     ],
    //     type: 'bar',
    //     barWidth: v.fontSizeRem(0.46)
    //   },
    //   {
    //     name: '手机APP',
    //     stack: '总量',
    //     data: [
    //       257183,
    //       211865,
    //       203147,
    //       199704,
    //       194739,
    //       198442,
    //       202129,
    //       190076,
    //       184714,
    //       177841,
    //       181869,
    //       184688,
    //       183749,
    //       164681,
    //       166182,
    //       153757,
    //       147238,
    //       155188,
    //       177744,
    //       167857,
    //       124122,
    //       123671,
    //       116535,
    //       109019,
    //       118357,
    //       145032,
    //       138638,
    //       99503
    //     ],
    //     type: 'bar'
    //   },
    //   {
    //     name: '阵列MIC',
    //     stack: '总量',
    //     data: [
    //       4344435,
    //       3581652,
    //       3537182,
    //       3705213,
    //       3772938,
    //       3881189,
    //       3910846,
    //       3818053,
    //       3829397,
    //       3782426,
    //       3749644,
    //       3808196,
    //       3810281,
    //       3502937,
    //       3534863,
    //       3336852,
    //       3195879,
    //       3272950,
    //       3663127,
    //       3603227,
    //       2874704,
    //       2861608,
    //       2785145,
    //       2746399,
    //       2924589,
    //       3472847,
    //       3404643,
    //       2668547
    //     ],
    //     type: 'bar'
    //   }
    // ]
  }
  return option
}
export function DailyActiveUsersEchartOp ({ v, data }) {
  let option = {
    tooltip: {
      trigger: 'axis'
    },
    grid: {
      left: '0%',
      top: '15%',
      right: '0%',
      bottom: '0%',
      containLabel: true
    },
    color: ['rgba(34, 186, 250, 1)', 'rgba(38, 98, 255, 1)', 'rgba(159, 75, 248, 1)', 'rgba(229, 87, 226, 1)'],
    legend: {
      icon: 'circle',
      data: [...data.name],
      ...LegendTextStyle({ v })
    },
    xAxis: {
      type: 'category',
      data: [...data.date],
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      }
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      },
      splitLine: yAxisSplitLine
    },
    series: data.data.map((item, index) => {
      return {
        name: data.name[index],
        stack: '总量',
        data: [...item],
        type: 'bar',
        barWidth: v.fontSizeRem(0.23)
      }
    })
    // series: [
    //   {
    //     name: '遥控器',
    //     stack: '总量',
    //     data: [
    //       9578332,
    //       8069789,
    //       8092250,
    //       8306762,
    //       8887755,
    //       9581125,
    //       10114489,
    //       10013010,
    //       10458061,
    //       10511640,
    //       10323448,
    //       9935482,
    //       9895495,
    //       9410479,
    //       9120847,
    //       8656161,
    //       7823567,
    //       8141873,
    //       10460866,
    //       9876738,
    //       6570897,
    //       6766098,
    //       6393808,
    //       5967237,
    //       6684122,
    //       9493461,
    //       9080549,
    //       5670928
    //     ],
    //     type: 'bar',
    //     barWidth: v.fontSizeRem(0.46)
    //   },
    //   // {
    //   //   name: '新增激活',
    //   //   stack: '总量',
    //   //   data: [
    //   //     18433,
    //   //     13538,
    //   //     11965,
    //   //     11524,
    //   //     10734,
    //   //     10693,
    //   //     10572,
    //   //     10130,
    //   //     10049,
    //   //     9915,
    //   //     9713,
    //   //     11434,
    //   //     10149,
    //   //     8279,
    //   //     8546,
    //   //     7922,
    //   //     7545,
    //   //     7430,
    //   //     8629,
    //   //     8447,
    //   //     6766,
    //   //     6720,
    //   //     6231,
    //   //     6012,
    //   //     5978,
    //   //     7595,
    //   //     7288,
    //   //     5772
    //   //   ],
    //   //   type: 'bar'
    //   // },
    //   {
    //     name: '手机APP',
    //     stack: '总量',
    //     data: [
    //       999547,
    //       800187,
    //       757336,
    //       748719,
    //       754519,
    //       769420,
    //       779515,
    //       741871,
    //       722325,
    //       735095,
    //       745684,
    //       728179,
    //       767329,
    //       668496,
    //       697473,
    //       605207,
    //       571447,
    //       609754,
    //       693574,
    //       686180,
    //       488847,
    //       491541,
    //       476082,
    //       445030,
    //       460124,
    //       605359,
    //       535882,
    //       388868
    //     ],
    //     type: 'bar'
    //   },
    //   {
    //     name: '阵列MIC',
    //     stack: '总量',
    //     data: [
    //       14087906,
    //       11855977,
    //       11936487,
    //       12525657,
    //       13109489,
    //       13807620,
    //       14533947,
    //       14379290,
    //       14582227,
    //       14445019,
    //       14592341,
    //       14253478,
    //       14338888,
    //       13654633,
    //       13325884,
    //       12784840,
    //       11845242,
    //       12122450,
    //       14718280,
    //       14130622,
    //       10244926,
    //       10227637,
    //       9909499,
    //       9565469,
    //       10293688,
    //       13640954,
    //       13219065,
    //       9178347
    //     ],
    //     type: 'bar'
    //   }
    // ]
  }
  return option
}
export function SpeechConversionFunnelEchartOp ({ v, data }) {
  let option = {
    color: [
      {
        'type': 'linear',
        'x': 0,
        'y': 1,
        'x2': 0,
        'y2': 0,
        'colorStops': [
          {
            'offset': 0,
            'color': '#FE35C9FF'
          },
          {
            'offset': 1,
            'color': '#F9737EFF'
          }
        ]
      },
      {
        'type': 'linear',
        'x': 0,
        'y': 1,
        'x2': 0,
        'y2': 0,
        'colorStops': [
          {
            'offset': 0,
            'color': '#37B4EEFF'
          },
          {
            'offset': 1,
            'color': '#3AF1C3FF'
          }
        ]
      },
      {
        'type': 'linear',
        'x': 0,
        'y': 1,
        'x2': 0,
        'y2': 0,
        'colorStops': [
          {
            'offset': 0,
            'color': '#565BFEFF'
          },
          {
            'offset': 1,
            'color': '#B945F5FF'
          }
        ]
      },
      {
        'type': 'linear',
        'x': 0,
        'y': 1,
        'x2': 0,
        'y2': 0,
        'colorStops': [
          {
            'offset': 0,
            'color': '#025EE2FF'
          },
          {
            'offset': 1,
            'color': '#29BAFFFF'
          }
        ]
      }
    ],
    legend: {
      show: false,
      data: ['展现', '点击', '访问', '咨询', '订单']
    },
    series: [
      {
        name: '漏斗图',
        type: 'funnel',
        top: 0,
        right: '0%',
        left: '25%',
        bottom: 0,
        min: 0,
        max: 100,
        minSize: '40%',
        maxSize: '100%',
        sort: 'descending',
        gap: 2,
        label: {
          show: true,
          position: 'leftTop',
          color: 'rgba(255, 255, 255,1)',
          formatter: function (d, c, a) {
            let cList = ['c', 'c1', 'c2', '']
            let textList = [...data.name]
            return `{${cList[d.dataIndex]}|}  {n|${textList[d.dataIndex]}}\n{percent|${d.data.percent}%}`
          },
          rich: {
            c: {
              width: v.fontSizeRem(0.45),
              height: v.fontSizeRem(0.45),
              backgroundColor: 'rgba(0, 114, 255, 1)',
              borderRadius: 50,
              verticalAlign: 'top'
            },
            c1: {
              width: v.fontSizeRem(0.45),
              height: v.fontSizeRem(0.45),
              backgroundColor: 'rgba(255, 218, 58, 1)',
              borderRadius: 50,
              verticalAlign: 'top'
            },
            c2: {
              width: v.fontSizeRem(0.45),
              height: v.fontSizeRem(0.45),
              backgroundColor: 'rgba(255, 95, 165, 1)',
              borderRadius: 50,
              verticalAlign: 'top'
            },
            percent: {
              fontSize: v.fontSizeRem(0.8),
              padding: [2, 0, 0, -10],
              alias: 'left'
            },
            n: {
              fontSize: v.fontSizeRem(0.65)
            }
          }
        },
        labelLine: {
          lineStyle: {
            width: 1,
            type: 'dashed'
          }
        },
        itemStyle: {
          borderColor: '#fff',
          borderWidth: 0.1
        },
        emphasis: {
          label: {
          }
        },
        data: [...data.lists]
        // data: [
        //   { value: 26620, percent: 0, name: '点击', label: { show: false } },
        //   { value: 19242, percent: 72.8, name: '访问' },
        //   { value: 19242, percent: 100, name: '咨询' },
        //   { value: 19182, percent: 99.69, name: '订单' }
        // ]
      },
      {
        name: '漏斗图',
        type: 'funnel',
        top: 0,
        right: '0%',
        left: '25%',
        bottom: 0,
        min: 0,
        max: 100,
        minSize: '40%',
        maxSize: '100%',
        sort: 'descending',
        gap: 2,
        label: {
          show: true,
          position: 'inside',
          color: 'rgba(255, 255, 255,1)',
          fontSize: v.fontSizeRem(1.14),
          formatter: function (d, c, a) {
            return d.data.v
          }
        },
        labelLine: {
          lineStyle: {
            width: 1,
            type: 'dashed'
          }
        },
        itemStyle: {
          borderColor: '#fff',
          borderWidth: 0.1
        },
        data: [...data.lists.map(item => { let { label, ...arg } = item; return { ...arg } })]
      }
    ]
  }

  return option
}

export function DialectDataEchartOp ({ v, data }) {
  // new echarts.graphic.LinearGradient(1, 0, 0, 1, [{ offset: 0, color: '#01C7E5' }, { offset: 1, color: '#042CF3' }])
  let option = {
    color: [],
    legend: {
      show: false,
      icon: 'circle',
      data: [...data.name],
      textStyle: {
        color: 'rgba(255, 255, 255, 0.8)'
      }
    },
    grid: {
      left: '0%',
      top: '0%',
      right: '10%',
      bottom: '0%',
      containLabel: true
    },
    xAxis: [{
      type: 'value',
      show: false,
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      },
      axisLine: {
        show: false
      }
    }],
    yAxis: [{
      type: 'category',
      data: [...data.name],
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      },
      axisLine: {
        show: false
      },
      splitLine: yAxisSplitLine,
      axisTick: {
        show: false
      }
    }],

    series: [{
      type: 'bar',
      color: {
        type: 'linear',
        x: 1,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [{
          offset: 0, color: '#01C7E5' // 0% 处的颜色
        }, {
          offset: 1, color: '#042CF3' // 100% 处的颜色
        }]
      },
      data: [...data.data],
      barWidth: v.fontSizeRem(1.25),
      showBackground: true,
      backgroundStyle: {
        color: 'rgba(255, 255, 255, 0.2)'
      },
      label: {
        normal: {
          position: 'insideRight',
          show: true,
          textBorderColor: '#333',
          textBorderWidth: 2,
          color: 'rgba(255,255,255,1)'
        }
      }
    }]
  }

  return option
}

export function HighFrequencyWordsEchartOp ({ v, list }) {
  // 字符串截取
  var wordLength = (value) => {
    var ret = '' // 拼接加\n返回的类目项
    var maxLength = 14 // 每项显示文字个数
    var valLength = value.length // X轴类目项的文字个数
    var rowN = Math.ceil(valLength / maxLength) // 类目项需要换行的行数
    if (rowN > 1) { // 如果类目项的文字大于3,
      for (var i = 0; i < rowN; i++) {
        var temp = '' // 每次截取的字符串
        var start = i * maxLength // 开始截取的位置
        var end = start + maxLength // 结束截取的位置
        // 这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧
        temp = value.substring(start, end) + '\n'
        ret += temp // 凭借最终的字符串
      }
      return ret
    } else {
      return value
    }
  }
  let data = [...list]
  //
  // var data = [{
  //   name: '关机',
  //   value: '5498358'
  // },
  // {
  //   name: '开机',
  //   value: '3095890'
  // },

  // {
  //   name: '打开电视',
  //   value: '1867042'
  // },
  // {
  //   name: '关闭电视',
  //   value: '880967'
  // },
  // {
  //   name: '暂停',
  //   value: '538211'
  // },
  // {
  //   name: '播放',
  //   value: '531652'
  // },
  // {
  //   name: '关电视',
  //   value: '449416'
  // },
  // {
  //   name: '返回',
  //   value: '385669'
  // },
  // {
  //   name: '中央一台',
  //   value: '375846'
  // },
  // {
  //   name: '下一集',
  //   value: '359543'
  // },
  // {
  //   name: '几点了',
  //   value: '359543'
  // }, {
  //   name: '下一页',
  //   value: '449416'
  // }, {
  //   name: '退出',
  //   value: '449416'
  // }, {
  //   name: '看电视',
  //   value: '449416'
  // }, {
  //   name: '中央四台',
  //   value: '449416'
  // }, {
  //   name: '打开',
  //   value: '449416'
  // }, {
  //   name: '请关机',
  //   value: '449416'
  // }, {
  //   name: '动画片',
  //   value: '449416'
  // }, {
  //   name: '打开电视机',
  //   value: '44941'
  // }, {
  //   name: '现在几点了',
  //   value: '449416'
  // }
  // ]
  // 偏移量
  var offsetData = [
    [50, 50],
    [35, 83],
    [80, 33],
    [60, 13],
    [2, 13],
    [100, 93],
    [20, 33],
    [90, 58],
    [10, 88],
    [10, 58],
    [18, 98],
    [68, 88],
    [98, 16],
    [34, 16],
    [94, 76]
  ]
  // symbolSize 散点气泡大小
  var symbolSizeData = [100, 85, 65, 62, 58, 55, 45, 42, 40, 33, 31, 61, 70, 44, 54]
  //
  // 循环定义series的data值
  var datas = []
  function getSize (i) {
    if (i === 12) { return v.fontSizeRem(0.008 * symbolSizeData[i]) }
    return v.fontSizeRem(0.01 * symbolSizeData[i])
  }
  for (var i = 0; i < data.length; i++) {
    var item = data[i]
    // var itemToStyle = datalist[i];
    let opacityCount = i * 0.1
    opacityCount = i * 0.1 > 0.4 ? 0.4 : opacityCount
    datas.push({
      // name: wordLength(item.name) + '\n' + item.value + '人',
      name: wordLength(item.name),
      value: offsetData[i],
      symbolSize: symbolSizeData[i],
      label: {
        color: 'rgba(255, 255, 255, 1)',
        fontSize: getSize(i),
        overflow: 'truncate'
      },
      itemStyle: {
        color: {
          type: 'radial',
          x: 0.3,
          y: 0.5,
          r: 0.7,
          colorStops: [{
            offset: 0, color: 'rgba(58, 141, 250, 1)' // 0% 处的颜色
          }, {
            offset: 1, color: 'rgba(27, 84, 244, 1)' // 100% 处的颜色
          }]
        },
        opacity: 1 - opacityCount,
        shadowColor: '#045878',
        shadowBlur: 10,
        shadowOffsetX: 1,
        shadowOffsetY: 1

      }
    })
  }

  let option = {
  //   backgroundColor: "transparent",
    // backgroundColor: '#0e2147',
    grid: {
      show: false,
      top: 10,
      bottom: 10
    },
    xAxis: [{
      gridIndex: 0,
      type: 'value',
      show: false,
      min: 0,
      max: 100,
      nameLocation: 'middle',
      nameGap: 5
    }],
    yAxis: [{
      gridIndex: 0,
      min: 0,
      show: false,
      max: 100,
      nameLocation: 'middle',
      nameGap: 30
    }],

    series: [{
      type: 'scatter',
      symbol: 'circle',
      symbolSize: 120,
      label: {
        with: 10000,
        show: true,
        formatter: '{b}',
        color: '#fff',
        textStyle: {
          fontSize: '20'
        }
      },
      itemStyle: {
        color: '#00acea'
      },
      data: datas
    }]
  }

  return option
}
